"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneTransferFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneTransferFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.25 3.196-.738-.738A1.563 1.563 0 0 0 3.404 2c-.4 0-.802.151-1.108.458a7.83 7.83 0 0 0 0 11.078l.034.033c.602.595 1.583.565 2.181-.034l.739-.738a1.044 1.044 0 0 0 0-1.477l-.649-.649a1.564 1.564 0 0 0-1.108-.458h-.598a.533.533 0 0 1-.375-.155.483.483 0 0 1-.117-.186 5.757 5.757 0 0 1 0-3.75.518.518 0 0 1 .493-.34h.597c.416 0 .814-.166 1.108-.46l.649-.649a1.044 1.044 0 0 0 0-1.477ZM15.69 3.196l-.738-.738A1.563 1.563 0 0 0 13.844 2c-.399 0-.801.151-1.108.458a7.83 7.83 0 0 0 0 11.078l.034.033c.602.595 1.584.565 2.182-.034l.738-.738a1.044 1.044 0 0 0 0-1.477l-.648-.649a1.564 1.564 0 0 0-1.108-.458h-.598a.533.533 0 0 1-.376-.155.483.483 0 0 1-.116-.186 5.757 5.757 0 0 1 0-3.75.518.518 0 0 1 .492-.34h.598c.415 0 .814-.166 1.107-.46l.65-.649a1.044 1.044 0 0 0 0-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.354 6.146a.5.5 0 1 0-.708.708l.647.646H5a.5.5 0 0 0 0 1h3.293l-.647.646a.5.5 0 1 0 .708.708l1.5-1.5a.5.5 0 0 0 0-.708l-1.5-1.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneTransferFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneTransferFill;
exports["default"] = _default;